const VIDEOS_API_BASE_PATH = '/v3/videos';

export const VIDEO_REPORT_MAX_DETAILS_LENGTH = 140;

export const VIDEO_FEED_API_PATH = `${VIDEOS_API_BASE_PATH}/feed`;

export const videoReportApiPath = (videoId: string): string =>
    `${VIDEOS_API_BASE_PATH}/${encodeURIComponent(videoId)}/reports`;
